import React from 'react'
import { tripjackDirectHotelApi } from '../../utils/Apis';

const DetailHotelTripJack = (props) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const handleRedirect = () => {
        window.open(`https://travvoo.com:6111/hotel-voucher?bookingId=${props?.data?.order?.bookingId}`, '_blank');
    };

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };


    return (
        <div className="content">
            <div className="intro-y flex flex-col sm:flex-row items-center mt-8">
                <h2 className="text-lg font-medium mr-auto">
                    Transaction Details
                </h2>
                <div className="w-full sm:w-auto flex mt-4 sm:mt-0">
                    <button className="btn btn-primary shadow-md mr-2" onClick={() => handleRedirect()}>Print</button>
                    <div className="dropdown ml-auto sm:ml-0">
                        {/* <button className="dropdown-toggle btn px-2 box" aria-expanded="false" data-tw-toggle="dropdown">
                            <span className="w-5 h-5 flex items-center justify-center"> <i className="w-4 h-4" data-lucide="plus"></i> </span>
                        </button> */}
                        {/* <div className="dropdown-menu w-40">
                            <ul className="dropdown-content">
                                <li>
                                    <a href="" className="dropdown-item"> <i data-lucide="file" className="w-4 h-4 mr-2"></i> Export Word </a>
                                </li>
                                <li>
                                    <a href="" className="dropdown-item"> <i data-lucide="file" className="w-4 h-4 mr-2"></i> Export PDF </a>
                                </li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="intro-y grid grid-cols-11 gap-5 mt-5">
                <div className="col-span-12 lg:col-span-4 2xl:col-span-3">
                    <div className="box p-5 rounded-md">
                        {
                            props?.data?.order?.status == "CANCELLED" ? null :

                                <div className="flex items-center border-b border-slate-200/60 dark:border-darkmode-400 pb-5 mb-5">
                                    <div className="font-medium text-base truncate">Transaction Details</div>
                                    <a href="#" onClick={() => {
                                        setIsOpen(true)
                                    }} className="flex items-center ml-auto text-primary"> <i data-lucide="edit" className="w-4 h-4 mr-2"></i> Change Status </a>
                                </div>
                        }

                        <div className="flex items-center"> <i data-lucide="clipboard" className="w-4 h-4 text-slate-500 mr-2"></i> Booking ID : <a href="" className="underline decoration-dotted ml-1">{props?.data?.order?.bookingId}</a> </div>
                        <div className="flex items-center mt-3"> <i data-lucide="calendar" className="w-4 h-4 text-slate-500 mr-2"></i> Booking Date: {props?.data?.order?.createdOn?.split("T")[0]} {props?.data?.order?.createdOn?.split("T")[1]} </div>
                        <div className="flex items-center mt-3"> <i data-lucide="clock" className="w-4 h-4 text-slate-500 mr-2"></i> Transaction Status: <span className="bg-success/20 text-success rounded px-2 ml-1">{props?.data?.order?.status}</span> </div>
                    </div>
                    <div className="box p-5 rounded-md mt-5">
                        <div className="flex items-center border-b border-slate-200/60 dark:border-darkmode-400 pb-5 mb-5">
                            <div className="font-medium text-base truncate">Buyer Information</div>
                            {/* <a href="" className="flex items-center ml-auto text-primary"> <i data-lucide="edit" className="w-4 h-4 mr-2"></i> View Details </a> */}
                        </div>
                        {/* <div className="flex items-center"> <i data-lucide="clipboard" className="w-4 h-4 text-slate-500 mr-2"></i> Name: <a href="" className="underline decoration-dotted ml-1">{"Robert De Niro"}</a> </div> */}
                        <div className="flex items-center mt-3"> <i data-lucide="calendar" className="w-4 h-4 text-slate-500 mr-2"></i> Phone Number: {props?.data?.order?.deliveryInfo.contacts[0]} </div>
                        <div className="flex items-center mt-3"> <i data-lucide="map-pin" className="w-4 h-4 text-slate-500 mr-2"></i> Email: {props?.data?.order?.deliveryInfo.emails[0]} </div>
                    </div>
                    <div className="box p-5 rounded-md mt-5">
                        <div className="flex items-center border-b border-slate-200/60 dark:border-darkmode-400 pb-5 mb-5">
                            <div className="font-medium text-base truncate">Payment Details</div>
                        </div>
                        <div className="flex items-center">
                            <i data-lucide="clipboard" className="w-4 h-4 text-slate-500 mr-2"></i> Payment Method:
                            <div className="ml-auto">Direct bank transfer</div>
                        </div>
                        <div className="flex items-center mt-3">
                            <i data-lucide="credit-card" className="w-4 h-4 text-slate-500 mr-2"></i> Total Price :
                            <div className="ml-auto">Rs. {props?.data?.order?.amount}</div>
                        </div>
                        <div className="flex items-center mt-3">
                            <i data-lucide="credit-card" className="w-4 h-4 text-slate-500 mr-2"></i> Convinence Fee:
                            {/* <div className="ml-auto">Rs. {10}</div> */}
                        </div>

                        <div className="flex items-center border-t border-slate-200/60 dark:border-darkmode-400 pt-5 mt-5 font-medium">
                            <i data-lucide="credit-card" className="w-4 h-4 text-slate-500 mr-2"></i> Grand Total:
                            <div className="ml-auto">Rs. {props?.data?.order?.amount}</div>
                        </div>
                    </div>

                </div>
                <div className="col-span-12 lg:col-span-7 2xl:col-span-8">
                    <div className="box p-5 rounded-md">
                        <div className="flex items-center border-b border-slate-200/60 dark:border-darkmode-400  mb-5">
                            <div className="font-medium text-base truncate">{props?.data?.itemInfos?.HOTEL?.hInfo?.name}</div>
                            {/* <a href="" className="flex items-center ml-auto text-primary"> <i data-lucide="plus" className="w-4 h-4 mr-2"></i> Add Notes </a> */}
                        </div>
                        <div className="flex items-center border-b border-slate-200/60 dark:border-darkmode-400 pb-5 mb-5">
                            <div className="font-medium text-base truncate">{props?.data?.itemInfos?.HOTEL?.hInfo?.ad?.adr}</div>
                            <div className="font-medium text-base truncate ml-2"> {props?.data?.itemInfos?.HOTEL?.hInfo?.ad?.postalCode}</div>
                            <div className="font-medium text-base truncate ml-2"> {props?.data?.itemInfos?.HOTEL?.hInfo?.ad?.city?.name}</div>
                        </div>
                        <div className="overflow-auto lg:overflow-visible -mt-3">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className="whitespace-nowrap !py-5">Name</th>
                                        <th className="whitespace-nowrap text-right">ID</th>
                                        <th className="whitespace-nowrap ">Travellers</th>
                                        <th className="whitespace-nowrap text-right">Check In</th>
                                        <th className="whitespace-nowrap text-right">Check Out</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {

                                        props?.data?.itemInfos.HOTEL.hInfo.ops[0]?.ris && props.data?.itemInfos.HOTEL.hInfo.ops[0]?.ris.length > 0
                                            ?
                                            props.data?.itemInfos.HOTEL.hInfo.ops[0]?.ris.map((item, index) => (
                                                <tr>
                                                    <td className="!py-4">
                                                        <div className="flex items-center">
                                                            <div className="w-10 h-10 image-fit zoom-in">
                                                                <img alt="Midone - HTML Admin Template" className="rounded-lg border-2 border-white shadow-md tooltip" src="dist/images/preview-2.jpg" title="Uploaded at 9 October 2020" />
                                                            </div>
                                                            <a href="" className="font-medium whitespace-nowrap ml-4">{item.rc}</a>
                                                        </div>
                                                    </td>
                                                    <td className="text-right">{item.id}</td>
                                                    <td>
                                                        {item?.ti && item?.ti.length > 0
                                                            ?
                                                            item?.ti.map((inneritem, innerindex) => (
                                                                <p>
                                                                    {inneritem?.ti} {inneritem?.fN} {inneritem?.lN} ( {inneritem?.pt} )
                                                                </p>
                                                            ))
                                                            :
                                                            null}

                                                    </td>
                                                    <td className="text-right">{item.checkInDate}</td>
                                                    <td className="text-right">{item.checkOutDate}</td>
                                                </tr>
                                            ))

                                            :
                                            null

                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: "24px",
                            width: "100%",
                            maxWidth: "400px",
                            position: "relative",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                        }}
                    >
                        {/* Close (×) button */}
                        <button
                            onClick={toggleModal}
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "16px",
                                background: "none",
                                border: "none",
                                fontSize: "20px",
                                color: "#888",
                                cursor: "pointer",
                            }}
                        >
                            &times;
                        </button>

                        <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "#333", marginBottom: "16px" }}>
                            Cancel Ticket
                        </h2>

                        <p style={{ color: "#555", marginBottom: "24px", fontWeight: "bold", fontSize: "16px" }}>
                            Are you sure you want to cancel your ticket? This action cannot be undone.
                        </p>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                            <button
                                onClick={toggleModal}
                                style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#28a745", // green
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                }}
                            >
                                Close
                            </button>
                            <button
                                onClick={() => {
                                    // Add your cancel logic here
                                    props.cancelBooking()
                                    toggleModal()
                                }}
                                style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#dc3545", // red
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DetailHotelTripJack